import { TopUpsFinance } from 'modules/Finance';
import React from 'react';

export function TopUpsConcierge() {
  // TopUps Purchase Package Concierge re-use TopUps Finance
  return (
    <React.Fragment>
      <TopUpsFinance isTopUpConcierge />
    </React.Fragment>
  );
}

export default TopUpsConcierge;
